import { PurchasePriceData } from 'chaika-frontend-types/frontend-cms';
import type { Optional } from 'chaika-common-types';

import { isDefined } from '@utils/isDefined';

import { SimpleList } from '../SimpleList';

interface FilterParams {
    id?: string;
    serviceId?: string;
}

export class PurchasePriceList extends SimpleList<PurchasePriceData, FilterParams> {
    public getPriceByServiceId(serviceId: string): Optional<PurchasePriceData> {
        return this.values.find(price => price.serviceId === serviceId);
    }

    public getLaboratoryPrice({
        laboratoryId,
        serviceId,
    }: Required<Pick<PurchasePriceData, 'serviceId' | 'laboratoryId'>>): Optional<PurchasePriceData> {
        return this.values.find(price => price.serviceId === serviceId && price.laboratoryId === laboratoryId);
    }

    public getLaboratoryPrices({
        laboratoryId,
        serviceId,
    }: Required<Pick<PurchasePriceData, 'serviceId' | 'laboratoryId'>>): Optional<PurchasePriceData[]> {
        return this.values.filter(price => price.serviceId === serviceId && price.laboratoryId === laboratoryId);
    }

    protected filterValue(value: PurchasePriceData, filters: FilterParams): boolean {
        const filterById = isDefined(filters.id) ? value.id === filters.id : true;
        const filterByServiceId = isDefined(filters.serviceId) ? value.serviceId === filters.serviceId : true;

        return filterById && filterByServiceId;
    }
}
